import { render, staticRenderFns } from "./stockSettingsPage.vue?vue&type=template&id=2943ecf2&"
import script from "./stockSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./stockSettingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports